import { memo } from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import TrustpilotStars from "app/features/booking/components/Trustpilot/TrustpilotStars";
import IconTrustpilotLogo from "app/features/booking/components/Trustpilot/IconTrustpilotLogo";
import "./Trustpilot.scss";

const TRUSTPILOT_MAX_RATING = 5;

type TrustpilotProps = {
	brandDisplayName?: string;
	rating?: number;
	totalReviews?: number;
};

const Trustpilot = ({ brandDisplayName, rating, totalReviews = 0 }: TrustpilotProps) => {
	if (!rating || rating <= 0) {
		return null;
	}

	return (
		<div className="trustpilot" data-testid="trustpilot">
			<div className="trustpilot__brand" data-testid="trustpilot-brand">
				{brandDisplayName}
			</div>

			<div className="trustpilot__rating" data-testid="trustpilot-rating">
				<FormattedMessage
					id="trustpilot.rating.label"
					values={{
						rating: (
							<FormattedNumber
								value={rating}
								minimumFractionDigits={1}
								maximumFractionDigits={1}
							/>
						),
						maxRating: TRUSTPILOT_MAX_RATING,
					}}
				/>
			</div>

			<TrustpilotStars rating={rating} />

			{totalReviews > 0 && (
				<div className="trustpilot__reviews" data-testid="trustpilot-reviews">
					<FormattedMessage
						id="trustpilot.reviews.based.on"
						values={{
							reviewsCount: <FormattedNumber value={totalReviews} />,
						}}
					/>
				</div>
			)}

			<div className="trustpilot__logo" data-testid="trustpilot-logo">
				<IconTrustpilotLogo />
			</div>
		</div>
	);
};

export default memo(Trustpilot);
